let General=[
  {
    "headlineEN": "How has my country voted at the UN?",
    "summaryEN": "We analysed 6,112 roll-call votes from the UN General Assembly from 1946 to 2018.\n\nExplore the biggest issues facing the planet and see how they have evolved.",
    "chapterEN": "UNGA: One country, one vote",
    "subEN": "Every September, leaders from around the world gather at the United Nations in New York to debate and pass resolutions on the biggest issues facing the planet. \n\nEstablished after World War II, the UN has grown from 51 members in 1945 to 193 members in 2019. It also has two non-member observer states, Palestine and The Holy See. \n\n",
    "headlineAR": "الأمم المتحدة في 74 عاما.. أحداث وقضايا \nكيف تفاعلت وصوتت دول العالم؟",
    "summaryAR": "قمنا بتحليل 6112 تصويتا للجمعية العامة للأمم المتحدة من عام 1946 حتى 2018، لنلقي الضوء على أكبر المشكلات والقضايا التي تواجه كوكبنا وكيف تطورت ولمعرفة مواقف مختلف دول العالم مع هذه القضايا وكيفية تعاملها مع القرارات الصادرة عن الجمعية العامة.",
    "chapterAR": "الجمعية العامة.. صوت لكل دولة",
    "subAR": "يجتمع قادة مختلف دول العالم في نيويورك كل عام، لمناقشة القضايا الكبرى التي تواجه الكوكب. لكل دولة منها صوت واحد. وتسهيلا لفهم القضايا الرئيسية التي نوقشت خلال العقود الماضية، قمنا بتحليل أنماط التصويت لجميع الدول الأعضاء في الأمم المتحدة من العام 1946 إلى 2018. \n\nوكانت الأمم المتحدة قد تأسست بعد الحرب العالمية الثانية، وقد زاد عدد الدول الأعضاء فيها من 51  دولة عضوا في عام 1945 إلى 193 دولة في عام 2019. وتضم الأمم المتحدة كذلك دولتين مراقبتين غير عضوين هما فلسطين والفاتيكان. فيما يأتي تسلسل زمني لتاريخ انضمام كل دولة إلى الأمم المتحدة. \n(مرر المؤشر فوق الأعلام لإظهار أسماء الدول)\n"
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "What have been the major topics of debate?",
    "subEN": "Most resolutions fall under six broad areas: the Israeli-Palestinian conflict, nuclear weapons, disarmament, human rights, colonialism and economic development.\n\nSome resolutions fall under two or more of these categories. See which of these topics ranks highest each year (Rank) or view the ratio of resolutions discussed each year (Frequency).",
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "ما القضايا الرئيسية المطروحة للنقاش؟",
    "subAR": "تندرج غالبية قرارات الأمم المتحدة ضمن ستة مجالات: الصراع الإسرائيلي الفلسطيني، والأسلحة النووية، ونزع السلاح، وحقوق الإنسان، والاستعمار، والتنمية الاقتصادية. وتصنف بعض القرارات ضمن فئتين أو أكثر من هذه الفئات. يمكنك التعرف إلى المواضيع التي تحتل المرتبة الأعلى كل عام (التصنيف) أو استعراض نسبة القرارات كل عام (التردد)."
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "How has every country voted?",
    "subEN": "Curious as to how your country voted over the entire history of the UN?\n\nScroll down to your region, you'll see the six major categories represented as coloured bars next to each country. \n\nClick on the bars to see the total number of times a country voted Yes, No, or Abstain on resolutions across the six major topics identified.\n\nYou'll also be able to see how voting patterns have developed across blocs and regions.",
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "كيف صوتت كل دولة؟",
    "subAR": "يمكنك الوقوف على القرارات التي صوت بلدك لصالحها أو ضدها أو امتنع عن التصويت بشأنها على مدى تاريخ الأمم المتحدة."
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Decade by decade",
    "subEN": "Click on a decade to see a summary of the UNGA's activities. ",
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "عقد بعقد",
    "subAR": "حدد الحقبة كي تطلع على ملخص لأنشطة الجمعية العامة خلال كل عقد."
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "What do you think is the most important issue facing the world today?",
    "subEN": "In the UN General Assembly, the rule is: One country, one vote for the delegations that come from every member state.\n\nTo understand what the key issues have been over the years, we have analysed the voting patterns of all UN member states from 1946 to 2018. ",
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "بتقديرك.. ما أهم قضية يواجهها العالم اليوم؟",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Who said it?",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "من القائل ؟",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Hover over the boxes for more information. The larger the box, the more often a topic was discussed.",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "للمزيد قم بجولة بين الخانات",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "VIEW KEY FACTS",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "استعراض الحقائق الأساسية",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "View slideshow",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "للاستعراض حلقة بحلقة",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Correct!",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "صحيح",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Wrong!",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "خطأ",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Submit",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "شارك",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Show/Hide annotations",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "استعراض /إخفاء الإيضاحات",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Hover over flags for more information",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "قم بجولة بين أعلام الدول",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Rank",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "تصنيف",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Frequency",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "تواتر",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Replay",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "استعرض مرة أخرى",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Highlights include:",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": "متعلقات",
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Voted yes",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": null,
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Voted no",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": null,
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Abstained",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": null,
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "When each country joined the UN:",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": null,
    "subAR": null
  },
  {
    "headlineEN": null,
    "summaryEN": null,
    "chapterEN": "Thank you for your feedback. Follow AJLabs on Twitter for more information",
    "subEN": null,
    "headlineAR": null,
    "summaryAR": null,
    "chapterAR": null,
    "subAR": null
  }
]
export default General